import * as React from 'react';
import { Column } from '@tanstack/react-table';
import { ArrowUpDown, ArrowUp, ArrowDown } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface TableSortButtonProps<TData> {
  column: Column<TData>;
  children: React.ReactNode;
}

export function TableSortButton<TData>({ column, children }: TableSortButtonProps<TData>) {
  if (!column.getCanSort()) return children;

  return (
    <Button
      variant="ghost"
      size="sm"
      className="-ml-3 h-8 data-[state=open]:bg-accent"
      onClick={column.getToggleSortingHandler()}
    >
      {children}
      {{
        asc: <ArrowUp className="ml-2 h-4 w-4" />,
        desc: <ArrowDown className="ml-2 h-4 w-4" />
      }[column.getIsSorted() as string] ?? <ArrowUpDown className="ml-2 h-4 w-4 opacity-50" />}
    </Button>
  );
}
